<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 14:09:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-12 11:47:49
-->
<template>
	<el-button v-if="!item.tooltipContent" :type="item.type" :disabled="item.disabled" :plain="item.plain" @click.stop="click(item)">
		<div :class="[item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '', item.notSelf ? 'notSelf' : '']">
			{{ item.label }}
		</div>
	</el-button>
	<el-tooltip
		v-else
		class="item"
		effect="dark"
		:content="item.tooltipContent || '仅上传者可修改'"
		:disabled="!item.disabledTooltip && !item.notSelf"
		:placement="item.placement || 'left'"
	>
		<el-button :type="item.type" :disabled="item.disabled" :plain="item.plain" @click.stop="click(item)">
			<div :class="[item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '', item.notSelf ? 'notSelf' : '']">
				{{ item.label }}
			</div>
		</el-button>
	</el-tooltip>
</template>
<script>
export default {
	name: 'TextButton',
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		rowIndex: {
			type: Number,
			default: 0,
		},
		row: {
			type: Object,
			default: () => ({}),
		},
	},
	methods: {
		click({ click }) {
			click && click(this.row, this.rowIndex);
		},
	},
};
</script>
<style lang="less">
.notSelf {
	color: #ddd !important;
}
.notSelf:hover {
	cursor: default;
	border-bottom: none;
}
</style>
